var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-center"},[_c('self-service'),_c('common-question'),_c('question-category')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }